import React from "react";
import { Link } from "react-router-dom";
import styles from "../InverluxApps.module.css";

const Support = () => (
  <section className={styles.pageSection}>
    <div className={styles.narrowWidth}>
      <p className={styles.eyebrow}>Inverlux Apps support</p>
      <h1>How can we help?</h1>
      <p className={styles.pageIntro}>
        For help with Tiny JPG &amp; PNG, Tab Group Share, or Collapse All for
        Gmail, email Inverlux LLC at the address below. There is no support
        form or account required.
      </p>

      <div className={styles.supportCard}>
        <p className={styles.supportLabel}>Public support email</p>
        <a href="mailto:support@inverlux.com">support@inverlux.com</a>
        <p>
          When reporting an issue, include the extension name and version,
          your Chrome version, a short description of what happened, and the
          steps that reproduce it. Please do not send sensitive email content,
          private URLs, research data, or sensitive images.
        </p>
      </div>

      <div className={styles.inlineLinks}>
        <Link to="/tiny-jpg-png">Tiny JPG &amp; PNG</Link>
        <Link to="/tiny-jpg-png/privacy">Tiny JPG &amp; PNG Privacy Policy</Link>
        <Link to="/tab-group-share">Tab Group Share</Link>
        <Link to="/tab-group-share/privacy">Tab Group Share Privacy Policy</Link>
        <Link to="/gmail-collapse-all">Collapse All for Gmail</Link>
        <Link to="/gmail-collapse-all/privacy">
          Collapse All for Gmail Privacy Policy
        </Link>
      </div>

      <div className={styles.sectionHeading}>
        <h2 className={styles.supportProductHeading}>Tiny JPG &amp; PNG help</h2>
        <p>
          Free supports 30 images per batch, up to 20 MB per image. For a
          compression or download issue, include the image format, approximate
          file size, and any error message. Please keep the extension tab open
          while downloading.
        </p>
        <p>
          Optional Pro costs $14.99 USD one-time, with no subscription and
          permanent Pro access for 3 active Chrome installations. A 30-day
          refund-request window applies from the date of purchase; email
          support@inverlux.com for refund requests.
        </p>
        <p>
          Pro payment and licensing are configured, but the extension is still
          awaiting Chrome Web Store release and remains Coming soon. Image
          compression stays local. Licensing runs on AWS in Oregon (us-west-2).
          Pro purchases, activation, and periodic license verification require
          internet access. For privacy or deletion
          requests, email support; include an order number only for Pro-related
          requests. Do not send a license key or payment details.
        </p>
      </div>

      <div className={styles.sectionHeading}>
        <h2 className={styles.supportProductHeading}>Tab Group Share help</h2>
        <p>
          The toolbar popup supports Chrome 123+. Native tab context-menu
          commands require Chrome 150+. If the menu commands are unavailable
          in your Chrome version, use the toolbar popup.
        </p>
        <p>
          For import issues, tell us the format (Plain Text, Markdown, or JSON),
          whether you are appending to an existing group or creating a new
          one, and what the preview shows. A sample with public or placeholder
          URLs is enough; please keep private tab lists out of support emails.
        </p>
      </div>
    </div>
  </section>
);

export default Support;
